import { fontSizes } from '../../constants/constants';
import CustomInput from '../../components/CustomInput';
import Text from '../../components/Text';
import Button from '../../components/Button';
import ViewReverse from '../../components/ViewReverse';
import ViewItems from '../../components/ViewItems';
import loginFunctional from './index.function';
import CustomCheckbox from '../../components/CustomCheckbox';
import AuthWrapper from '../../components/AuthWrapper';
import { Formik } from 'formik';
import { login_validation_schema } from '../../validations_schemas/login_validation_schema';
import ErrorText from '../../components/ErrorText';
import images from '../../constants/images';
import Language from '../../components/Language';
import { RowView } from '../CorporateForm/components';

const Login = () => {
  const { passwordRef, TextWeight, authLoading, handleLogin, getContentKey, navigate, isRemembered, setIsRemembered, username, isArabic } =
    loginFunctional();

  return (
    <AuthWrapper>
      <ViewItems className={`w-full`}>
        <RowView className='justify-between items-center'>
          <img src={images.textLogo} width={70} />
          <div className="flex justify-end">
            <Language isLogin />
          </div>
        </RowView>

        <Formik
          validationSchema={login_validation_schema}
          initialValues={{
            username: username || '',
            password: '',
          }}
          validateOnChange={false}
          validateOnMount={false}
          validateOnBlur={false}
          onSubmit={(values) => handleLogin(values)}
          className='w-full'
        >
          {({ handleSubmit, setFieldValue, setFieldError, values, errors }) => {
            const isValid = values.username && values.password;

            return (
              <>
                <Text text={getContentKey('login')} weight={TextWeight.semiBold} size={fontSizes.h18} className={'mb-5 mt-10'} />

                <CustomInput
                  label={getContentKey('client_id')}
                  placeholder={getContentKey('client_id_placeholder')}
                  isRequired
                  value={values?.username}
                  onChange={(e) => {
                    setFieldValue('username', e.target.value);
                    setFieldError('username', null);
                  }}
                  canEnterSpace={false}
                  onPressEnter={() => passwordRef?.current?.focus()}
                />
                <ErrorText text={errors?.username} getContentKey={getContentKey} />

                <CustomInput
                  label={getContentKey('password')}
                  placeholder={getContentKey('password_placeholder')}
                  type='password'
                  isRequired
                  divClasses={'mt-4'}
                  value={values.password}
                  onChange={(e) => {
                    setFieldValue('password', e.target.value);
                    setFieldError('password', null);
                  }}
                  isPassword={true}
                  onPressEnter={handleSubmit}
                  canEnterSpace={false}
                  props={{
                    ref: passwordRef,
                  }}
                />
                <ErrorText text={errors?.password} getContentKey={getContentKey} />

                <ViewReverse className={`justify-between items-center mt-3 w-full`}>
                  <CustomCheckbox label={getContentKey('remember')} isChecked={isRemembered} onClick={() => setIsRemembered(!isRemembered)} />

                  <Text
                    text={getContentKey('forgot_password')}
                    color={'text-primary'}
                    className={'cursor-pointer underline'}
                    size={fontSizes.h13}
                    onClick={() => navigate('/forget-password')}
                  />
                </ViewReverse>

                <ViewItems className={'w-full gap-3'}>
                  <Button
                    text={getContentKey('login_btn')}
                    className={'mt-6 w-full'}
                    onClick={handleSubmit}
                    loading={authLoading}
                    isDisabled={!isValid}
                  />

                  <Button
                    text={getContentKey('sign_up')}
                    bgColor='bg-white'
                    color='text-primary'
                    className={'w-full border border-primary'}
                    onClick={() => window.open(process.env.REACT_APP_JOIN_US_LINK + `?languageId=${isArabic ? 4 : 3}`, '_self')}
                  />
                  <Button
                    text={getContentKey('activate_account')}
                    bgColor='bg-white'
                    color='text-primary'
                    className={'w-full border border-primary'}
                    onClick={() => navigate('/active-account')}
                  />
                </ViewItems>
              </>
            );
          }}
        </Formik>
      </ViewItems>
    </AuthWrapper>
  );
};

export default Login;
